import React from 'react';
import { useParams } from 'react-router-dom';
import { UserImportReport } from '../users/import/UserImportReport';

/**
 * One import's results report at /admin/imports/:importId (from the import history, the
 * upload, or the import's finished notification). Imports are only users for now, so this
 * is the user import report.
 */
export const ImportReportPage = () => {
	const { importId } = useParams();
	return <UserImportReport key={importId} importId={importId} />;
};
